// extracted by mini-css-extract-plugin
module.exports = {"folder-svg":"FolderBanner-module__folder-svg___1B69c","container":"FolderBanner-module__container___23o_s"};